import React from 'react';
import { Link } from 'react-router-dom';

import { TEACHERS_HOME_URL } from 'config/urls';

import styles from './styles.module.scss';

const NavTitle = ({ title, subtitle, Icon }) => (
  <div className={styles.navHeaderGroup}>
    <div className={styles.navTitleRow}>
      <Link to={TEACHERS_HOME_URL}>
        {Icon && <Icon className={styles.homeIcon} />}
      </Link>
      <span>{title}</span>
    </div>
    <div className={styles.navSubtext}>{subtitle}</div>
  </div>
);

export default NavTitle;
